export default __webpack_public_path__ + "b209c74985218f27ef0b96a4cb2b585d.svg";